<template>
    <div class="options-container">
        <ul>
            <li v-for="pokemon in pokemons" 
                :key="pokemon.id"
                @click="$emit( 'selectionPokemon', pokemon.id )">
                {{ pokemon.name }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        pokemons: {
            type: Array,
            required: true
        }
    }    
}
</script>
<style scoped>
ul {
    list-style-type: none;
    padding: 0;
    margin: 20px 0;
}

li {
    background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
    border-radius: 12px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    cursor: pointer;
    margin-bottom: 12px;
    width: 280px;
    padding: 15px 20px;
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
    text-transform: capitalize;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
}

li:hover {
    background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
    transform: translateX(5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
    border-color: #fcb69f;
}

li:active {
    transform: translateX(2px);
}

.options-container {
    display: flex;
    justify-content: center;
}
</style>